import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./modal.m.css";

function Modal({ children, isOpen, onClose, innerClassName }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
    return () => {
      document.body.style.overflow = "visible";
    };
  }, [isOpen]);

  const closeModal = () => {
    onClose();
  };

  if (isOpen) {
    const modalContent = (
      <div className="modal-container" onClick={closeModal}>
        <div className={`modal-inner${innerClassName ? ` ${innerClassName}` : ""}`} onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      </div>
    );

    if (typeof window !== "undefined") {
      return createPortal(modalContent, document.body);
    }
    return modalContent;
  }
  return null;
}

export default Modal;
